// src/slices/companyprice/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getCompanies, getCompanyOne } from "./thunk";
const initialState = { companies: [], companyOne: null, loading: false, error: null };

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload?.data || [];
      })

      .addCase(getCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //  getone
      .addCase(getCompanyOne.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyOne.fulfilled, (state, action) => {
        state.loading = false;
        state.companyOne = action.payload?.data;
      })
      .addCase(getCompanyOne.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default companySlice.reducer;
